module.exports = __webpack_public_path__ + "media/paws/dark-paws-8dcec0c3.svg";